// translation.config.ts
import { InjectionToken } from '@angular/core';

export interface LanguageInfo {
  code: string;
  name: string;
}

export interface TranslationConfig {
  languages: LanguageInfo[]; // e.g. [{code: 'en', name: 'English'}, {code: 'es', name: 'Español'}]
  default: string;      // e.g. 'en'
  useUrl?: boolean;     // prefix routes with /:lang if true
  storageKey?: string;  // defaults to 'app.lang'
}

export const TRANSLATION_CONFIG = new InjectionToken<TranslationConfig>('TRANSLATION_CONFIG');
